mutation addUser($id: ID!, $roleId: ID!, $scopes: [InputUserScope]) {
    addUser(id: $id, roleId: $roleId, scopes: $scopes) {
        id
        isNewUser
        role {
            _id
            __typename
        }
        scope {
            client
            campaign
            __typename
        }
        __typename
    }
}
